import { render, staticRenderFns } from "./PredictionRadarChartOverview.vue?vue&type=template&id=2294b0fc&scoped=true"
import script from "./PredictionRadarChartOverview.vue?vue&type=script&lang=js"
export * from "./PredictionRadarChartOverview.vue?vue&type=script&lang=js"
import style0 from "./PredictionRadarChartOverview.vue?vue&type=style&index=0&id=2294b0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2294b0fc",
  null
  
)

export default component.exports